import Fetcher from '../../common/util/Fetcher';
import { handleQuizAnalysisResponse } from '../../common/api/callHandlers';
import { markQuizAnalysisNotFound } from '../../common/actions/reporting';
import { associateQuizAnalysis } from '../../common/actions/quizzes';
export function getQuizAnalysis(quizId) {
  var url = "/api/quizzes/".concat(quizId, "/stats/quiz_analysis");
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      onError: function onError() {
        return markQuizAnalysisNotFound(quizId);
      }
    });
    return fetcher.get(url).then(function (response) {
      dispatch([handleQuizAnalysisResponse(response), associateQuizAnalysis(quizId, response)]);
    });
  };
}